import { request, setTokens, clearTokens, getRefreshToken } from './apiClient';
import { AuthResponse, ApiUser } from '../types/api';

export async function login(
  email: string,
  password: string
): Promise<{ user: ApiUser; error: null } | { user: null; error: Error }> {
  try {
    const data = await request<AuthResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    setTokens(data.access_token, data.refresh_token);
    return { user: data.user, error: null };
  } catch (err) {
    return { user: null, error: err as Error };
  }
}

export async function register(
  email: string,
  password: string,
  fullName: string
): Promise<{ user: ApiUser; error: null } | { user: null; error: Error }> {
  try {
    const data = await request<AuthResponse>('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, full_name: fullName }),
    });
    setTokens(data.access_token, data.refresh_token);
    return { user: data.user, error: null };
  } catch (err) {
    return { user: null, error: err as Error };
  }
}

export async function logout(): Promise<{ error: Error | null }> {
  try {
    await request<void>('/auth/logout', { method: 'POST' });
  } catch {
    // ignore logout failures
  }
  clearTokens();
  return { error: null };
}

export async function getCurrentUser(): Promise<ApiUser | null> {
  try {
    return await request<ApiUser>('/auth/me', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('towapp_access_token') || ''}`,
      },
    });
  } catch {
    return null;
  }
}

export async function refreshSession(): Promise<boolean> {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return false;
  try {
    const data = await request<AuthResponse>('/auth/refresh', {
      method: 'POST',
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    setTokens(data.access_token, data.refresh_token);
    return true;
  } catch {
    clearTokens();
    return false;
  }
}
